import { render, staticRenderFns } from "./TriviaChoice.vue?vue&type=template&id=23563db0&"
import script from "./TriviaChoice.vue?vue&type=script&lang=js&"
export * from "./TriviaChoice.vue?vue&type=script&lang=js&"
import style0 from "./TriviaChoice.vue?vue&type=style&index=0&id=23563db0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports